module.exports = "/_next/static/images/desktop_hero_en-ea9fe5f3bb82f30a670ccd3c99a80167.webp";